<template>
    <div class="bg-grey-700 theme-dark">
        <div class="container pb-16 sm:pb-20 lg:pb-28">
            <PageHeader title="Jazzy műsorok" class="mb-12 sm:mb-16" />

            <div class="grid grid-cols-12 gap-5">
                <div
                    v-for="(item, i) in showsListWithBannersAndAdsInserted"
                    :key="`item-${i}`"
                    :class="!/(banner|ad)/.test(item.type) ? 'col-span-6 md:col-span-4 lg:col-span-3' : 'col-span-12'"
                >
                    <Ad
                        v-if="item.type === 'ad'"
                        desktop-id="adoceangemhutlcilnkhwr"
                        mobile-id="adoceangemhuobefdkphaq"
                    />
                    <BannerCard
                        v-else-if="item.type === 'banner' && centerBannerData"
                        :title="centerBannerData.public_title"
                        :label="centerBannerData.surtitle"
                        :button-text="centerBannerData.button_text"
                        :slug="centerBannerData.button_url"
                        :desc="centerBannerData.content"
                        :image="centerBannerData.image"
                        :color="centerBannerData.scheme"
                        :reversed="centerBannerData.type"
                        class="my-12"
                    />
                    <EntityCard
                        v-else-if="!/(banner|ad)/.test(item.type)"
                        :to="`/musorok/${item.slug}`"
                        :image="item.cover_image"
                        :color="item.color"
                        :title="item.title"
                        :description="item.subtitle"
                    />
                </div>

                <div v-if="bottomBannerData" class="col-span-12 my-12">
                    <BannerCard
                        :title="bottomBannerData.public_title"
                        :label="bottomBannerData.surtitle"
                        :button-text="bottomBannerData.button_text"
                        :slug="bottomBannerData.button_url"
                        :desc="bottomBannerData.content"
                        :image="bottomBannerData.image"
                        :color="bottomBannerData.scheme"
                        :reversed="bottomBannerData.type"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from '../../components/Generic/PageHeader/PageHeader';
import EntityCard from '../../components/Cards/EntityCard/EntityCard';
import BannerCard from '../../components/Cards/BannerCard/BannerCard';
import Ad from '../../components/Generic/Ad';

export default {
    name: 'MusorIndex',
    components: {
        PageHeader,
        EntityCard,
        BannerCard,
        Ad,
    },
    async asyncData({ $axios }) {
        let showsListWithBannersAndAdsInserted = null;

        try {
            await $axios
                .$get('/show')
                .then((res) => {
                    if (res.success === 1) {
                        showsListWithBannersAndAdsInserted = res.data;
                        showsListWithBannersAndAdsInserted.splice(8, 0, { type: 'banner' });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        return { showsListWithBannersAndAdsInserted };
    },
    head() {
        return {
            title: 'Jazzy műsorok',
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: 'Jazzy műsorok',
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: 'Jazzy műsorok',
                },
            ],
        };
    },
    computed: {
        centerBannerData() {
            return this.getPromotionBox('shows-center');
        },
        bottomBannerData() {
            return this.getPromotionBox('shows-bottom');
        },
    },
};
</script>

<style scoped></style>
